<template>
    <div class="">
        <div style="" class="rightTitle mt-2 clearfix text-left ">
            <!--SKÚSENOSTI-->
            <div class="">{{$t("experiences.1")}}</div>
        </div>

        <experiences-info-set   v-for="(content,i ) in oContent" 
                                :key="i"
                                :record="content"   
                                :graduallyView="graduallyView"   />
        <div id="sector_7" class="experiences"  >
            <div style="" class="rightTitle mt-4 clearfix ">
                <!--PORTFÓLIO-->
                <div class="portfolio text-left">{{$t("experiences.7.1")}}</div>
            </div>          
            <div class="">
                <div style="" class="rightLine mt-2 clearfix ">
                    <div class="bold clearfix text-left"><a href="https://abnet.sk" target="_NEW">https://abnet.sk</a></div>
                </div>                                   
                <!--
                <div style="" class="rightLine mt-2 clearfix ">
                    <div class="bold clearfix text-left"><a href="https://dash.econec-tech.eu" target="_NEW">https://dash.econec-tech.eu</a></div>
                </div>                   
                <div style="" class="rightLine mt-2 clearfix ">
                    <div class="bold clearfix text-left"><a href="https://fermata.sk" target="_NEW">https://fermata.sk</a></div>
                </div>
                -->
            </div>       
        </div>                               
    </div>
</template>

<script>
    import ExperiencesInfoSet from "@/components/ExperiencesInfoSet.vue"
    import oExperiences from "@/assets/JSON/Experiences"
    export default {
        components: {
            ExperiencesInfoSet,
        },
        data() {
            return {
                oContent: oExperiences,
                graduallyView:"none"   //
            }
        },
        methods: {
            gradually() {
                let setTime = 5000
                for(let i=1;i<=11;++i)  {
                    
                    setTimeout(() => {

                        let oSector = document.getElementById("sector_"+i)
                        if(oSector!==null)
                            oSector.style.display="inline"
                    }, setTime);

                    setTime += 1000
                }
            }
        },
        mounted () {
            if(this.graduallyView.trim().toLowerCase().length>0) this.gradually()
        },
    }
</script>

<style lang="scss" scoped>

</style>